import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Store} from '@ngrx/store';
import {filter, take, tap} from 'rxjs/operators';
import { LicenseEntity } from '../entities/license.entity';
import { State } from '../State';
import { ResolverLoadAllLicenses } from '../State/actions/resolver.actions';

@Injectable({
    providedIn: 'root'
})
export class LicenseAllResolver implements Resolve<LicenseEntity[]> {
    constructor(private store: Store<State>) {
    }

    resolve() {
        const value$ = this.store.select(state => state.licenses.licensList);
        value$
            .pipe(
                filter(value => !value),
                take(1),
                tap(() => {
                    if (localStorage.getItem('token') != null) {
                        this.store.dispatch(new ResolverLoadAllLicenses());
                    }
                })
            )
            .subscribe();

        return value$.pipe(
            filter(value => !!value),
            take(1)
        );
    }
}
